import React, { useRef, useState } from 'react'
// import Counter from '../components/Counter'
import { Link } from 'react-router-dom'
// import InspirationSlider from '../components/InspirationSlider';
import { submitContactForm } from '../services/emailService'

export default function Home() {
  const form = useRef(null)
  const [status, setStatus] = useState(null)

  const handleSubmit = (e) => {
    e.preventDefault()
    setStatus('sending')

    submitContactForm(form.current, 'home-page')
      .then(() => {
        setStatus('success')
        form.current.reset()
      })
      .catch(() => {
        setStatus('error')
      })
  }

  return (
    <div>
      <div className="container-fluid bg-primary py-5 hero-header-height">
        <div className="container py-5">
          <div className="row justify-content-center py-5">
            <div className="col-lg-10 pt-lg-5 mt-lg-5 text-center">
              <h1 className="display-3 text-white mb-3 animated slideInDown">
               Travel with <br></br><span className="italic-text">Unforgettable</span>  Memory 

              </h1>
             <div className="d-flex justify-content-center mt-5 animated slideInDown">
  <button
    type="button"
    className="btn btn-secondary rounded-pill py-3 px-4"
  >
    Start Your Journey
    <span className="fa fa-arrow-right ps-3" />
  </button>
</div>

              
            </div>
          </div>
        </div>
      </div>
      {/* <!-- About Section Start --> */}
<div
  className="container-fluid py-5"
  style={{
    backgroundImage: "url('/assets/img/home_about.png')",
    backgroundPosition: "center",
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    position: "relative"
  }}
>
  <div
    style={{
      position: "absolute",
      inset: 0,
      background: "rgba(0, 102, 122, 0.7)"
    }}
  ></div>

  <div
    className="container position-relative text-center text-white"
    style={{ zIndex: 5 }}
  >
    <h1 className="mb-4" style={{ fontWeight: 600, color: "#fff" }}>
      About Ceylonsman
    </h1>

    <p className="mb-4" style={{ maxWidth: 900, margin: "auto" }}>
      At Ceylonsman Travels, we craft exceptional journeys for the discerning
      traveler. With a deep appreciation for elegance and detail, we offer bespoke
      travel experiences that reflect your unique tastes and aspirations. Our
      dedicated team is available 24/7 to ensure every moment of your journey is
      seamless, indulgent, and unforgettable, from your first inquiry to your safe
      return home.
    </p>

    <p className="mb-5" style={{ maxWidth: 900, margin: "auto" }}>
      Discover exceptional value without compromising on quality. At Ceylonsman
      Travels, we specialize in creating unforgettable holiday experiences at the
      best possible rates. Our dedicated Travel Managers are available anytime to
      assist you with questions, concerns, or personalized travel planning. We look
      forward to making your next holiday truly exceptional.
    </p>

    {/* Stats */}
    {/* <div className="row mt-4">
      <div className="col-md-3 col-6 mb-4">
        <Counter end={60} />
        <p>Destination Experts</p>
      </div>
      <div className="col-md-3 col-6 mb-4">
         <Counter end={5} />
        
        <p>Destinations</p>
      </div>
      <div className="col-md-3 col-6 mb-4">
        <Counter end={100} />
        <p>Different Tours</p>
      </div>
      <div className="col-md-3 col-6 mb-4">
        <Counter end={1} />
        <p>Year of Experiences</p>
      </div>
    </div> */}
  </div>
</div>

{/* Destinations */}

<section className="container my-5">
  <h2 className="text-center mb-4" style={{ fontWeight: 700, fontSize: "42px" }}>
    Destinations
  </h2>

    <div className="row justify-content-center g-4">

    {/* Sri Lanka */}
    <div className="col-md-6">
      {/* <Link to="/destination/srilanka" style={{ textDecoration: 'none', color: 'inherit' }}></Link> */}
      <Link to="" style={{ textDecoration: 'none', color: 'inherit' }}>
      <div
       className="destination-card wow fadeInUp"
        data-wow-delay="0.1s"
        style={{
          borderRadius: "20px",
          overflow: "hidden",
          position: "relative",
        }}
      >
        <img
          src="/assets/img/srilanka.png"
          alt="Sri Lanka"
          style={{ width: "100%", height: "100%", objectFit: "cover" }}
        />

        <div
          style={{
            position: "absolute",
            bottom: 25,
            left: 25,
            color: "white",
          }}
        >
          <h3 style={{ fontSize: "28px", fontWeight: 600,color:"#fff" }}>Sri Lanka</h3>
          <p style={{ margin: 0, fontSize: "18px" }}>20+ Tours   50+ Destination Experts</p>
        </div>
      </div>
      </Link>
    </div>

    {/* Maldives */}
    <div className="col-md-6">
      <div
       className="destination-card wow fadeInUp"
       data-wow-delay="0.1s"
        style={{
          borderRadius: "20px",
          overflow: "hidden",
          position: "relative",
        }}
      >
        <img
          src="/assets/img/maldives.png"
          alt="Maldives"
          style={{ width: "100%", height: "100%", objectFit: "cover" }}
        />

        <div
          style={{
            position: "absolute",
            bottom: 25,
            left: 25,
            color: "white",
          }}
        >
          <h3 style={{ fontSize: "28px", fontWeight: 600,color:"#fff" }}>Maldives</h3>
          <p style={{ margin: 0, fontSize: "18px" }}>30+ Tours   65+ Destination Experts</p>
        </div>
      </div>
    </div>

  </div>
</section>
 
{/* Offers Section: two side-by-side cards */}
<section className="container my-5">
  <h2 className="text-center mb-4" style={{ fontWeight: 700, fontSize: "36px" }}>
    Enjoy with
    <br />
    Ceylonsman Tourers
  </h2>

  <div className="row g-4">
    <div className="col-md-6">
      <div className="offer-card p-4">
        <div className="offer-badge">10% OFF</div>
        <h3 className="offer-title">Flexible Individual Travel</h3>
        <p className="offer-price">Starting from <span style={{ color: 'var(--secondary)', fontWeight: 700 }}>USD 500</span> per person</p>

        <p className="offer-intro">“Your Journey, Your Way.” Perfect for families and individuals who value privacy, complete flexibility, and personalized experiences.</p>

        <ul className="offer-list">
          <li>Private Trip for ultimate comfort and exclusivity</li>
          <li>Fully customized itinerary to match your preferences</li>
          <li>Private vehicle and dedicated driver guide for seamless travel</li>
          <li>Dedicated Destination Expert to curate unforgettable experiences</li>
          <li>24/7 care for peace of mind</li>
          <li>Personal Account Manager for end-to-end support</li>
        </ul>

        <p className="offer-desc">Enjoy the freedom to explore at your own pace without the constraints of fixed schedules or shared groups. Every detail from accommodations to activities is tailored to your unique preferences.</p>
      </div>
    </div>

    <div className="col-md-6">
      <div className="offer-card p-4">
        <div className="offer-badge">15% OFF</div>
        <h3 className="offer-title">Group Tours</h3>
        <p className="offer-price">Starting from <span style={{ color: 'var(--secondary)', fontWeight: 700 }}>USD 1000</span> per person</p>

        <p className="offer-intro">Explore Together, Travel Smarter. Perfect for travelers who enjoy the camaraderie of a small group and prefer a structured itinerary with set dates.</p>

        <ul className="offer-list">
          <li>Travel in intimate groups of up to 12 guests</li>
          <li>Fixed tour plan and scheduled departure dates</li>
          <li>Shared transportation for a seamless experience</li>
          <li>Limited flexibility during the journey</li>
          <li>Dedicated Destination Expert to guide you</li>
          <li>24/7 assistance for peace of mind</li>
          <li>Personal Account Manager for end-to-end support</li>
        </ul>
      </div>
    </div>
  </div>
</section>

{/* slider */}
{/* <section style={{ backgroundColor: "#E8F8FC" }} className="py-5">
  <div className="container text-center">
    <h2 className="mb-3" style={{ fontSize: "48px" }}>
      Inspiration and New
      <br /> Discoveries Await
    </h2>

    <p className="mb-5" style={{ maxWidth: "700px", margin: "0 auto" }}>
      Travel differently. Embrace the allure of adventure off the beaten path
      and let yourself be inspired by unique, unforgettable experiences.
    </p>

    <InspirationSlider />
  </div>
</section> */}

    <section class="quote-section py-5">
  <div class="container text-center">

    <h2 class="mb-5 heading-quote">How to get a Quote</h2>

    <div class="position-relative d-flex justify-content-between align-items-center line-wrapper">

      {/* <!-- Horizontal Line --> */}
      <div class="horizontal-line"></div>

      {/* <!-- Step 1 --> */}
      <div class="step-item text-center">
        <div class="icon-circle">
           <img src="/assets/img/fa_user_group.svg" width="50" alt="group" />
        </div>
        <h5 class="mt-3 fw-bold" style={{ color: "#ffffff" }}>Connect with a Local Expert</h5>
        <p class="step-text">
          Submit your travel preferences and details to get started with personalized planning.
        </p>
      </div>

      {/* <!-- Step 2 --> */}
      <div class="step-item text-center">
        <div class="icon-circle">
          <img src="/assets/img/fa-comments.svg" width="50" alt="group" />
  
        </div>
        <h5 class="mt-3 fw-bold" style={{ color: "#ffffff" }}>Enjoy a Free Consultation</h5>
        <p class="step-text">
          Our local expert will craft a detailed itinerary tailored to your interests, budget, and schedule.
        </p>
      </div>

      {/* <!-- Step 3 --> */}
      <div class="step-item text-center">
        <div class="icon-circle">
           <img src="/assets/img/fa-plane-departure.svg" width="50" alt="group" />
        
        </div>
        <h5 class="mt-3 fw-bold" style={{ color: "#ffffff" }}>Confirm & Travel with Confidence</h5>
        <p class="step-text">
          Secure your bookings and embark on a seamless, stress-free journey.
        </p>
      </div>

    </div>
  </div>
</section> 


    <section className="contact-section container-fluid p-0">
      <div className="row g-0">

        {/* LEFT FORM */}
        <div className="col-lg-6 p-5 form-area">
          <h1 className="form-title">
            We'd love to hear <br /> from you!
          </h1>

          <form ref={form} onSubmit={handleSubmit} className="mt-4">

            <div className="row">
              <div className="col-md-6 mb-3">
                <label>First Name*</label>
                <input
                  name="user_firstname"
                  type="text"
                  className="form-control form-input"
                  placeholder="Your First Name"
                  required
                />
              </div>

              <div className="col-md-6 mb-3">
                <label>Last Name*</label>
                <input
                  name="user_lastname"
                  type="text"
                  className="form-control form-input"
                  placeholder="Your Last Name"
                  required
                />
              </div>
            </div>

            <div className="row">
              <div className="col-md-6 mb-3">
                <label>Email*</label>
                <input
                  name="user_email"
                  type="email"
                  className="form-control form-input"
                  placeholder="Email Address"
                  required
                />
              </div>

              <div className="col-md-6 mb-3">
                <label>Contact Number*</label>
                <input
                  name="contact_number"
                  type="text"
                  className="form-control form-input"
                  placeholder="Contact Number"
                  required
                />
              </div>
            </div>

            <div className="mb-3">
              <label>Tell us about your travel plans*</label>
              <textarea
                name="message"
                className="form-control form-input"
                rows="3"
                placeholder="Enter Your Message"
                required
              />
            </div>

            {/* CHECKBOX */}
            <div className="form-check mb-3">
              <input name="subscribe" type="checkbox" className="form-check-input" />
              <label className="form-check-label">
                I want to receive the latest travel news, insights and offers to my inbox.
              </label>
            </div>

            {/* PRIVACY TEXT */}
            <p className="privacy-text">
              By providing my contact details and clicking 'Submit', I consent to being
              contacted via phone, SMS, and email with travel-related information.
              No purchase is necessary. We respect your <span>privacy</span>.
            </p>

            {/* SUBMIT BUTTON */}
            <button type="submit" className="submit-btn">Submit</button>

            {status === 'sending' && (
              <p className="text-secondary mt-3">Sending message...</p>
            )}
            {status === 'success' && (
              <p className="text-success mt-3">Thanks! Your message has been sent.</p>
            )}
            {status === 'error' && (
              <p className="text-danger mt-3">Oops! Something went wrong. Please try again.</p>
            )}
          </form>
        </div>

        {/* RIGHT IMAGE */}
        <div className="col-lg-6">
          <div className="image-side"></div>
        </div>
      </div>
    </section>
    </div>
  )
}
